// extracted by mini-css-extract-plugin
export default {"overlay":"tLVDDZ","openOverlay":"S8968W","mounted":"_pY0DF"};